import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarTaxi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCarTaxi"><Path fillRule="evenodd" clipRule="evenodd" d="M15 4H17.3975L21.1367 9.5H23V11H22V20H16.5V17.9287H7.5V20H2V11H1V9.5H2.86328L6.60254 4H9V2.25H15V4ZM5 14H8V12.5H5V14ZM16 14H19V12.5H16V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarTaxi;
